const AppointmentBooking = () => {
  return (
    <section className="py-20 bg-gradient-to-br from-purple-50 to-pink-50">
      <div className="max-w-7xl mx-auto px-6">
        <div className="grid lg:grid-cols-2 gap-12 items-center">
          {/* Left - Conversation Flow */}
          <div className="space-y-6">
            <div className="space-y-4">
              {/* Customer message */}
              <div className="flex items-start gap-3">
                <div className="w-10 h-10 bg-gray-300 rounded-full flex items-center justify-center flex-shrink-0">
                  <i className="ri-user-line text-gray-700"></i>
                </div>
                <div className="bg-white rounded-2xl rounded-tl-none p-4 shadow-md max-w-md">
                  <p className="text-gray-800">Hi, I'd like to schedule an appointment for next week.</p>
                </div>
              </div>
              
              {/* Genie response */}
              <div className="flex items-start gap-3 justify-end">
                <div className="bg-gradient-to-r from-pink-500 to-purple-500 rounded-2xl rounded-tr-none p-4 shadow-md max-w-md">
                  <p className="text-white">Of course! I'd be happy to help you schedule an appointment. What day works best for you?</p>
                </div>
                <img 
                  src="https://static.readdy.ai/image/f188085399ab07ac2c79984c802b33af/d7137dec17d438e55dac1175e416585f.png" 
                  alt="Genie" 
                  className="w-10 h-10 flex-shrink-0"
                />
              </div>
              
              {/* Customer message */}
              <div className="flex items-start gap-3">
                <div className="w-10 h-10 bg-gray-300 rounded-full flex items-center justify-center flex-shrink-0">
                  <i className="ri-user-line text-gray-700"></i>
                </div>
                <div className="bg-white rounded-2xl rounded-tl-none p-4 shadow-md max-w-md">
                  <p className="text-gray-800">Tuesday afternoon would be perfect.</p>
                </div>
              </div>
              
              {/* Genie response with calendar */}
              <div className="flex items-start gap-3 justify-end">
                <div className="bg-gradient-to-r from-pink-500 to-purple-500 rounded-2xl rounded-tr-none p-4 shadow-md max-w-md">
                  <p className="text-white mb-3">Great! I have these times available on Tuesday:</p>
                  <div className="space-y-2">
                    <div className="bg-white/20 backdrop-blur-sm rounded-lg p-2 text-white text-sm">
                      <i className="ri-time-line mr-2"></i>2:00 PM - 3:00 PM
                    </div>
                    <div className="bg-white/20 backdrop-blur-sm rounded-lg p-2 text-white text-sm">
                      <i className="ri-time-line mr-2"></i>3:30 PM - 4:30 PM
                    </div>
                    <div className="bg-white/20 backdrop-blur-sm rounded-lg p-2 text-white text-sm">
                      <i className="ri-time-line mr-2"></i>5:00 PM - 6:00 PM
                    </div>
                  </div>
                </div>
                <img 
                  src="https://static.readdy.ai/image/f188085399ab07ac2c79984c802b33af/d7137dec17d438e55dac1175e416585f.png" 
                  alt="Genie" 
                  className="w-10 h-10 flex-shrink-0"
                />
              </div>
              
              {/* Customer message */}
              <div className="flex items-start gap-3">
                <div className="w-10 h-10 bg-gray-300 rounded-full flex items-center justify-center flex-shrink-0">
                  <i className="ri-user-line text-gray-700"></i>
                </div>
                <div className="bg-white rounded-2xl rounded-tl-none p-4 shadow-md max-w-md">
                  <p className="text-gray-800">2:00 PM works great!</p>
                </div>
              </div>
              
              {/* Genie confirmation */}
              <div className="flex items-start gap-3 justify-end">
                <div className="bg-gradient-to-r from-pink-500 to-purple-500 rounded-2xl rounded-tr-none p-4 shadow-md max-w-md">
                  <p className="text-white">Perfect! You're all set for Tuesday at 2:00 PM. I've sent a confirmation to your phone. See you then!</p>
                  <div className="mt-3 bg-white/20 backdrop-blur-sm rounded-lg p-3">
                    <div className="flex items-center gap-2 text-white text-sm">
                      <i className="ri-check-double-line text-lg"></i>
                      <span>Appointment Confirmed</span>
                    </div>
                  </div>
                </div>
                <img 
                  src="https://static.readdy.ai/image/f188085399ab07ac2c79984c802b33af/d7137dec17d438e55dac1175e416585f.png" 
                  alt="Genie" 
                  className="w-10 h-10 flex-shrink-0"
                />
              </div>
            </div>
          </div>
          
          {/* Right - Content */}
          <div className="space-y-8">
            <div>
              <h2 className="text-4xl lg:text-5xl font-bold text-gray-900 mb-6">
                Book Appointments Automatically
              </h2>
              <p className="text-xl text-gray-600 leading-relaxed mb-6">
                ReceptionGenie sends interested prospects a link to schedule on your calendar—so new opportunities get booked right onto your calendar.
              </p>
            </div>
            
            <div className="space-y-4">
              <div className="flex items-start gap-4">
                <div className="w-12 h-12 bg-pink-100 rounded-xl flex items-center justify-center flex-shrink-0">
                  <i className="ri-calendar-line text-pink-600 text-2xl"></i>
                </div>
                <div>
                  <h3 className="font-bold text-gray-900 text-lg mb-2">Syncs with Your Calendar</h3>
                  <p className="text-gray-600">Integrates seamlessly with Google Calendar, Outlook, and other popular calendar apps.</p>
                </div>
              </div>
              
              <div className="flex items-start gap-4">
                <div className="w-12 h-12 bg-purple-100 rounded-xl flex items-center justify-center flex-shrink-0">
                  <i className="ri-notification-line text-purple-600 text-2xl"></i>
                </div>
                <div>
                  <h3 className="font-bold text-gray-900 text-lg mb-2">Automatic Reminders</h3>
                  <p className="text-gray-600">Sends confirmation and reminder messages to reduce no-shows.</p>
                </div>
              </div>
              
              <div className="flex items-start gap-4">
                <div className="w-12 h-12 bg-blue-100 rounded-xl flex items-center justify-center flex-shrink-0">
                  <i className="ri-time-line text-blue-600 text-2xl"></i>
                </div>
                <div>
                  <h3 className="font-bold text-gray-900 text-lg mb-2">Real-Time Availability</h3>
                  <p className="text-gray-600">Only shows available time slots based on your actual schedule.</p>
                </div>
              </div>
            </div>
            
            <div className="bg-white rounded-2xl p-6 shadow-lg">
              <div className="flex items-center justify-between mb-4">
                <div className="text-sm font-semibold text-gray-500">This Week's Bookings</div>
                <div className="text-2xl font-bold text-pink-600">+18</div>
              </div>
              <div className="h-2 bg-gray-200 rounded-full overflow-hidden">
                <div className="h-full bg-gradient-to-r from-pink-500 to-purple-500 rounded-full" style={{ width: '75%' }}></div>
              </div>
              <div className="text-xs text-gray-500 mt-2">75% increase from last week</div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default AppointmentBooking;